/**
 .js-parallax {
    transform: scale(1.3);
    transform-origin: 50% 100%;
  }
 */
import throttle from '../vendor/lodash-es/throttle';

const els = document.querySelectorAll( '.js-parallax' );
const delayUpdate = 30;

let wh = isNaN( window.innerHeight ) ? window.clientHeight : window.innerHeight;

[ ...els ].forEach( ( el ) => {
  const parent = el.parentNode;
  let top = getOffsetSum( el ).top;
  let height = parent.clientHeight;
  let maxOffset = el.getBoundingClientRect().height - height;

  window.addEventListener( 'scroll', throttle( scrolling, delayUpdate ), false );
  window.addEventListener( 'resize', throttle( resizeUpdate, delayUpdate ), false );

  scrolling();

  function resizeUpdate() {
    wh = isNaN( window.innerHeight ) ? window.clientHeight : window.innerHeight;
    top = getOffsetSum( el ).top;
    height = parent.clientHeight;
    maxOffset = el.getBoundingClientRect().height - height;

    scrolling();
  }

  function scrolling() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const elVisible = scrollTop < top + height;

    if ( elVisible && scrollTop + wh > top ) {
      const ratio = ( scrollTop + wh - top ) / ( wh + height );
      const offset = maxOffset * ratio;

      el.style.transform = `scale(1.3) translate3d(0,${parseInt( offset, 10 )}px,0)`;
    }
  }
} );

function getOffsetSum( elem ) {
  let top = 0;
  let left = 0;

  while ( elem ) {
    top = top + parseFloat( elem.offsetTop );
    left = left + parseFloat( elem.offsetLeft );
    elem = elem.offsetParent;
  }

  return {
    top: Math.round( top ),
    left: Math.round( left ),
  };
}
